













import Person from '@/types/Person.interface'
import Vue, { PropType } from 'vue'
import ExtensionOption from '@/types/ExtensionOption.interface'
import { mapGetters } from 'vuex'
import { isEmpty } from '@/utility/helpers'
import HiddenInput from '@/types/HiddenInput.interface'
import HiddenInputComponent from './HiddenInput.vue'
export default Vue.extend({
    components: { 'hidden-input': HiddenInputComponent },
    props: {
        //  Indicates if the component is in editing mode
        readonly: {
            type: Boolean,
            default: false
        },
        //  The person we are displaying/editing
        person: {
            type: Object as PropType<Person>,
            required: true
        }
    },
    computed: {
        ...mapGetters(['extensionOptions']),
        isExtensionsEmpty(): boolean {
            return isEmpty(this.extensionOptions)
        },
        extensionItems(): HiddenInput[] {
            return this.extensionOptions.map((x: ExtensionOption) => ({
                date: x.type === 'date',
                mask: x.type === 'phone' ? '(###) ###-####' : null,
                select: x.type === 'dropdown',
                selectData: x.data,
                name: x.name,
                label: x.name,
                filter: this.getFilter(x),
                validate: this.getValidation(x),
                value: this.person.extensions[x.name],
                callback: (val: string) => {
                    /*
                     * When setting a key => value that does not exist yet, we have to use 'this.$set' to
                     * get the changes to stick. This is due to how reactive elements are registered. Read
                     * more here: https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
                     */

                    //  Update the person extension
                    this.$set(this.person.extensions, x.name, val)
                }
            }))
        }
    },
    methods: {
        //  Retrieve an optional filter for the extension option
        getFilter(extension: ExtensionOption): string | null {
            //  Get the extension type
            const type = extension.type

            //  Select the filter name
            const filter = { phone: 'phone' }[type]

            //  If a custom filter exists, return it
            if (filter) return filter

            //  Else, return null
            return null
        },
        //  Retrieve the validation rules for the entension's type
        getValidation(extension: ExtensionOption): string {
            //  Get the extension type
            const type = extension.type

            //  Select the validation rules based on the type
            const rules = {
                date: null,
                phone: 'phone|max:20',
                text: 'max:75',
                number: 'decimal',
                dropdown: null
            }[type]

            //  Return the validation rules
            return rules
        }
    }
})
